import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    width: '28px',
    height: '28px',
    viewBox: '0 0 28px 28px',
    '& path': {
      fill: '#000000',
      fillOpacity: '0.54',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  },
})

export default styleOverride
